import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Dropdown } from 'components/dropdown';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './InputDropdown.scss';

export default class InputDropdown extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    classNameMenu: PropTypes.string,
    classNameToggle: PropTypes.string,
    placeholder: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    isOpened: PropTypes.func
  };

  state = {
    open: false
  };

  static Close = Dropdown.Close;

  constructor(props) {
    super(props);
    this.isOpened = this.isOpened.bind(this);
  }

  isOpened(active) {
    const { isOpened } = this.props;

    this.setState({ open: active });

    isOpened && isOpened(active);
  }

  get className() {
    const { className } = this.props;

    return classNames('input', className);
  }

  get selected() {
    const { selected, placeholder = 'general.choose_option' } = this.props;

    return selected || <I18n label={placeholder} />;
  }

  render() {
    const {
      children,
      onClick,
      className,
      classNameMenu,
      classNameToggle,
      ...props
    } = this.props;
    const { open } = this.state;

    return (
      <Dropdown
        {...props}
        dropdownToggle={this.selected}
        className={classNames('input__dropdown', className)}
        classNameMenu={classNameMenu}
        classNameToggle={classNames('input', classNameToggle)}
        onClick={onClick}
        isOpened={this.isOpened}
        icon={
          <FontAwesomeIcon
            icon={['fal', open ? 'chevron-up' : 'chevron-down']}
          />
        }
      >
        {children}
      </Dropdown>
    );
  }
}
